<template>
  <pict
    class="format-banner-shortcasts-image__image"
    block-name="format-banner-shortcasts-image"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"

import imageLEN from "./images/shortcasts-desktop-en.png"
import imageL2xEN from "./images/shortcasts-desktop-en@2x.png"
import imageMEN from "./images/shortcasts-tablet-en.png"
import imageM2xEN from "./images/shortcasts-tablet-en@2x.png"
import imageSEN from "./images/shortcasts-mobile-en.png"
import imageS2xEN from "./images/shortcasts-mobile-en@2x.png"
import imageLDE from "./images/shortcasts-desktop-de.png"
import imageL2xDE from "./images/shortcasts-desktop-de@2x.png"
import imageMDE from "./images/shortcasts-tablet-de.png"
import imageM2xDE from "./images/shortcasts-tablet-de@2x.png"
import imageSDE from "./images/shortcasts-mobile-de.png"
import imageS2xDE from "./images/shortcasts-mobile-de@2x.png"

export default {
  name: "FormatBannerShortcastsImage",
  components: {
    Pict
  },
  computed: {
    useDEImages() {
      return this.$i18n.locale === "de"
    },
    imageProps() {
      return {
        default: {
          src: this.useDEImages ? imageLDE : imageLEN,
          srcset: {
            "2x": this.useDEImages ? imageL2xDE : imageL2xEN
          }
        },
        sources: [
          {
            media: "s",
            src: this.useDEImages ? imageSDE : imageSEN,
            srcset: {
              "2x": this.useDEImages ? imageS2xDE : imageS2xEN
            }
          },
          {
            media: "m",
            src: this.useDEImages ? imageMDE : imageMEN,
            srcset: {
              "2x": this.useDEImages ? imageM2xDE : imageM2xEN
            }
          }
        ]
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "Some Shortcast Covers"
      },
      de: {
        alt: "Einige Shortcast Cover"
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.format-banner-shortcasts-image {
  ::v-deep &__image {
    width: 100%;
  }
}
</style>
